import type { TierPrice } from '@pylot-data/pylotschema'
import type { ReactElement } from 'react'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { formatPrice } from '@corratech/pylot-price'
import s from '@pagestyles/PDP.module.scss'

export type ProductPrice = {
    tierPrice: [TierPrice]
}

export const ProductTierPrice = ({ tierPrice }: ProductPrice): ReactElement => {
    const { locale = 'en' } = useRouter()
    const { t } = useTranslation(['pdp'])

    return (
        <ul className={s['PDP-tier-price']}>
            {tierPrice?.map(({ quantity, final_price, discount }) => {
                if (quantity && final_price) {
                    return (
                        <li key={quantity}>
                            {t('Buy {{quantity}} for {{price}} each and ', {
                                quantity,
                                price: formatPrice(final_price, locale)
                            })}
                            {discount && (
                                <strong>
                                    {t('save {{percent}}%', {
                                        percent: Math.round(
                                            discount.percent_off as number
                                        )
                                    })}
                                </strong>
                            )}
                        </li>
                    )
                }
            })}
        </ul>
    )
}
